import BusinessIcon from '@mui/icons-material/Business'
import OrganizationList from './OrganizationList'
import OrganizationShow from './OrganizationShow'
import OrganizationEdit from './OrganizationEdit'

export default {
  list: OrganizationList,
  show: OrganizationShow,
  edit: OrganizationEdit,
  icon: BusinessIcon,
}
